import React from 'react'
import { useNavigate } from 'react-router-dom'

const BottomBanner = () => {
  const navigate = useNavigate();
  
  return (
    <>
            {/* bottom banner section */}
            <section className='bottom-banner-bg'>
        <div className='container py-5'>

          <p className='banner-heading col-lg-5 col-md-8'>Doctor's Recommended Range</p>
          <p className='col-lg-5 col-md-8 fw-semibold'>Discover a range of doctor-recommended products at KCM Online Store. From trusted
            medicines to healthcare essentials, we ensure you receive the best for your well-being, with expert-approved quality.</p>
          <button className='banner-btn animate__animated animate__pulse animate__infinite' onClick={() => navigate('/shop')}>Shop Now</button>

        </div>
      </section>
      {/* bottom banner section ends */}
    </>
  )
}

export default BottomBanner
